<template>
    <div class="header">
      <b-container>
        <b-row>
          <b-col class="logo" cols="12" sm="3" md="4" lg="4" xl="4">
            <img v-if="language == 'ru'" src="../assets/logo_ru.png">
            <img v-else src="../assets/logo_en.png">
          </b-col>
          <b-col cols="12" sm="9" md="6" lg="4" xl="4" offset-md="2" offset-lg="4" offset-xl="4">
            <b-row>
              <b-col cols="2" sm="2" md="12" lg="12" xl="12" order="2" order-sm="2" order-md="1" order-lg="1" order-xl="1">
                <div class="lang_wrap">
                  <a href="/?lang=en" class="lang en" v-bind:class="{ active: language == 'en' }" @click.prevent = "clickLanguage('en')"></a>
                  <a href="/?lang=ru" class="lang ru" v-bind:class="{ active: language == 'ru' }" @click.prevent = "clickLanguage('ru')"></a>
                </div>
              </b-col>
              <b-col cols="10" sm="10" md="12" lg="12" xl="12" order="1" order-sm="1" order-md="2" order-lg="2" order-xl="2">
                <div class="phone_header">
                  <div class="phone">
                    <a href="tel:+78312660230">
                      <span>8 (831)</span> 266-02-30
                    </a>
                  </div>
                  <div class="callback"><a href="">{{callback[language]}}</a></div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </div>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    language: {
      type: String,
      default: 'ru'
    }
  },
  data() {
    return {
      callback: {
        ru: 'Заказать звонок',
        en: 'Callback'
      }
    };
  },
  methods: {
    clickLanguage (lang) {
      this.$emit('clickLanguage', lang);
    }
  }
};
</script>

<style lang="scss">
@media (min-width: 992px) and (max-width: 1199px) {
}
@media (min-width: 768px) and (max-width: 991px) {
}
@media (min-width: 576px) and (max-width: 767px) {
  .header .logo {text-align: center;margin-bottom: 5px}
  .header .logo img { height: 50px!important;}
}
@media (max-width: 575px) {
  .header .logo {text-align: center;margin-bottom: 5px}
  .header .logo img {height: 50px!important;  }
  .header .phone_header .phone a{font-size: 22px!important;}
}
  .header {padding-top: 10px;padding-bottom: 10px;}
  .header .logo img {height: 85px;}
  .header .phone_header{text-align: right}
  .header .phone_header .phone::before{content: url("../assets/icon_header_phone.png");display: inline-block; height: 26px;vertical-align: top;margin-right: 10px;}
  .header .phone_header .phone a{text-decoration: none;font-size: 26px; color: #342e37;line-height: 26px}
  .header .phone_header .phone a:hover{opacity: 0.8}
  .header .phone_header .phone a span{font-weight: 300;}
  .header .phone_header .callback a{color: #94bc25;font-size: 18px;border-bottom: 1px dashed #94bc25;display: inline-block;text-decoration: none;}
  .header .lang_wrap{text-align: right}
  .header .lang_wrap .lang{width: 32px;height: 22px;display: inline-block;overflow: 0.8; border: 2px solid #fff;border-radius: 4px;overflow: hidden;box-sizing: border-box;}
  .header .lang_wrap .ru{background: url("../assets/icon_header_ru.png") center center no-repeat;}
  .header .lang_wrap .en{background: url("../assets/icon_header_en.png") center center no-repeat;}
  .header .lang_wrap .active, .header .lang_wrap .lang:hover{overflow: 1; border: 2px solid #94bd25;}
</style>


// WEBPACK FOOTER //
// src/views/Header.vue